import { HttpHeaders } from '@angular/common/http';

// export const API_URL = 'https://workspace.cacebenin.bj/stream';

export const API_URL = 'http://localhost:6060';

export const ERROR_MESSAGE = `Oups! Nous avons rencontré un soucis. Si cela persiste, veuillez contacter l'adminstrateur. Merci`;

export const HTTP_OPTIONS = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content-Type, Accept'
  })
};

export const CONNECTED_USER_KEY = 'CONNECTED_USER_KEY';

export const CONNECTED_USER_CURRENT_PROFILE_KEY = 'CONNECTED_USER_CURRENT_PROFILE_KEY';

export const ROUTES = {
  personne: {
    oneWithReference: API_URL + '/personne/personne-physique/get',
    send: API_URL + '/personne/personne-physique-tmp/creer-personne-physique-tmp',
    cace: API_URL + '/personne/personne-physique/get-by-id/14',
    one: API_URL + '/personne/personne-physique-tmp/get-by-id/14',
    oneWithMatricule: API_URL + '/personne/personne-physique/get-by-matricule/',
  },

  offre: {
    list: API_URL + '/service/offre/list-desc',
    one: API_URL + '/service/offre/get-by-id' 
  },

  offreCritere: {
    list: API_URL + '/service/offre-critere/list-desc',
    one: API_URL + '/service/offre-critere/get-by-id',
    useOffreID: API_URL + '/service/offre-critere/get-by-offre-id/'
  },

  offreService: {
    one: API_URL + '/service/offre-critere/get-by-id',
    useOffreID: API_URL + '/service/offre-service/get-by-offre-id/'
  },

  site: {
    list: API_URL + '/service/service/list-desc/1',
    one: API_URL + '/service/service/get-by-id'
  },

  adressService: {
    forService: API_URL + '/adresse/adresse/get-adresse-by-service'
  },

  periodicite: {
    list: API_URL + '/service/periodicite/list-filter-by-date-fin',
    one: API_URL + '/service/periodicite/get-by-id',
    useServiceID: API_URL + '/service/periodicite/get-by-service'
  },

  annee: {
    list: API_URL + '/inscription/annee-academique/list-desc',
    one: API_URL + '/inscription/annee-academique/get-by-id',
  },

  // bloc: {
  //   send: API_URL + '/inscription/inscription/creer-inscription-list'
  // },

  inscription: {
    send: API_URL + '/inscription/inscription/creer-inscription-list',
    forfait: API_URL + '/personne/forfait/get-actif-by-type-forfait/FORFAIT_PARTENAIRE'
  },

  demande: {
    send: API_URL + '/personne/demande/creer-demande-list',
    matieres: API_URL + '/personne/matiere/list-desc',
    classes: API_URL + '/personne/niveau-domaine-etude/list-desc'
  }

};

export const MAPKEY = {
  mapbox:{
    accessToken: 'PUT-YOUR-TOKEN-HERE'
  }
}
